import { type TranslationTree } from '@/i18n/types';

export const messages = {
  caption: 'Prévia no app',
  partner: 'Parceiro · {{name}}',
  titlePlaceholder: 'Título da oferta',
  bodyPlaceholder: 'O texto da oferta aparece aqui.',
  dismiss: 'Agora não',
  ctaPlaceholder: 'Botão',
  locationMore: '{{place}} e mais {{count}}',
} satisfies TranslationTree;
